import { useState } from "react";
import { CardContent } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

import type { NoteTemplate } from "@/common/types/notesTemplates";

interface Props {
  file: NoteTemplate;
  children: React.ReactNode;
  isOpen?: boolean;
}

export const CardContentTemplate = (props: Props): React.ReactNode => {
  const [isTemplateOpen, setIsTemplateOpen] = useState<boolean>(
    props.isOpen ?? false
  );

  return (
    <CardContent className="p-6 border-t">
      <Collapsible open={isTemplateOpen} onOpenChange={setIsTemplateOpen}>
        <CollapsibleTrigger className="flex w-full items-center justify-between">
          <div className="flex flex-col items-start ">
            <h3 className="text-lg font-bold">{props.file.template}</h3>
            <p className="text-sm text-grey-400">
              {`${props.file.style} - ${props.file.format} - ${props.file.exam}`}
            </p>
          </div>
          <ChevronDown
            className={cn(
              "h-5 w-5 text-grey-400 transition-transform duration-200",
              isTemplateOpen && "transform rotate-180"
            )}
          />
        </CollapsibleTrigger>
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3, ease: [0.645, 0.045, 0.355, 1] }}
          animate={
            isTemplateOpen
              ? { opacity: 1, height: "auto" }
              : { opacity: 0, height: 0 }
          }
        >
          <CollapsibleContent className="mt-4">
            {props.children}
          </CollapsibleContent>
        </motion.div>
      </Collapsible>
    </CardContent>
  );
};
